import { useMutation, useQueryClient } from "@tanstack/react-query";

import { decideCoverCropDetections } from "services";

import { invalidateQueriesAfterFieldsBulkUpdate } from "utils";

import { DECIDE_COVER_CROP_DETECTIONS, GET_FARM_DATA_SUBMISSION_STATUS, GET_PENDING_COVER_CROP_DETECTIONS } from "consts";

export const useDecideCoverCropDetections = ({ farmId, fieldIds }: { farmId?: string; fieldIds: string[] }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [DECIDE_COVER_CROP_DETECTIONS, farmId],
    mutationFn: decideCoverCropDetections,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_PENDING_COVER_CROP_DETECTIONS, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId] });
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};
